import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, user, loading } = useAuth();

  React.useEffect(() => {
    if (!loading && user) {
      if (user.is_admin) navigate('/admin');
      else navigate('/');
    }
  }, [user, loading, navigate]);

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-logo">C. LLAGUNO</h1>
        <p className="login-subtitle">Admin Access</p>
        <p className="login-text">
          Sign in with your Google account to manage artworks.
        </p>
        <Button onClick={login} className="login-button" data-testid="google-login-btn">
          Sign in with Google
        </Button>
        <button className="login-back" onClick={() => navigate('/')}>
          ← Back to site
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
